export const SET_LOADING = 'src/store/dashboard/SET_LOADING'
export const SET_COUNT = 'src/store/dashboard/SET_COUNT'
export const SET_VISIT = 'src/store/dashboard/SET_VISIT'
export const SET_REVENUE_MONTH = 'src/store/dashboard/SET_REVENUE_MONTH'
export const SET_STATISTIC = 'src/store/dashboard/SET_STATISTIC'
export const SET_REVENUE = 'src/store/dashboard/SET_REVENUE'
export const SET_TRANSACTION = 'src/store/dashboard/SET_TRANSACTION'
export const SET_TOP_REVENUE = 'src/store/dashboard/SET_TOP_REVENUE'

